import {isFeatureEnabled} from 'feature-flags';

import {EntityResourceIds} from '@dms/api/shared';
import {useGetMetadaServiceCaseQuery, useGetServiceCaseOrdersQuery} from '@dms/api/workshop';
import {featureFlags} from '@dms/feature-flags';
import {ActivitySidebarAction, ActivitySidebarV2} from '@dms/features/activity-panel';
import {buildCustomNoticesSidebarAction} from '@dms/features/custom-notices';
import i18n from '@dms/i18n';
import {usePermissions} from '@dms/shared';

import {buildArray} from 'shared/web';

import {ServiceCaseActivityTab} from './components/ServiceCaseActivityTab';
import {ServiceCaseCommentsTab} from './components/ServiceCaseCommentsTab';
import {ServiceCaseCommunicationThreadTab} from './components/ServiceCaseCommunicationThreadTab';

interface ServiceCaseActivityPanelProps {
  serviceCaseId: string;
}

export function ServiceCaseActivityPanel(props: ServiceCaseActivityPanelProps) {
  const {data: serviceCase} = useGetMetadaServiceCaseQuery({serviceCaseId: props.serviceCaseId});
  const {data: serviceOrders = []} = useGetServiceCaseOrdersQuery({
    serviceCaseId: props.serviceCaseId,
  });

  const [canReadServiceCase] = usePermissions({
    permissionKeys: ['serviceCaseRead'],
    scopes: {
      serviceCaseRead: {
        // BE Handles SC ACL
        branchId: 'SKIP',
        // BE Handles SC ACL
        serviceCaseType: 'SKIP',
      },
    },
  });

  const actions = buildArray<ActivitySidebarAction>()
    .when(canReadServiceCase, {
      id: 'activity',
      label: i18n.t('entity.activityPanel.activity.title'),
      icon: 'sidebar/activity',
      component: (
        <ServiceCaseActivityTab
          serviceCaseId={props.serviceCaseId}
          serviceCase={serviceCase}
          serviceOrders={serviceOrders}
        />
      ),
    })
    .when(canReadServiceCase && isFeatureEnabled(featureFlags.MESSAGE_SYNCHRONIZATION), {
      id: 'communication',
      label: i18n.t('entity.activityPanel.communicationThread.title'),
      icon: 'communication/thread',
      component: (
        <ServiceCaseCommunicationThreadTab
          serviceCaseId={props.serviceCaseId}
          serviceCase={serviceCase}
          serviceOrders={serviceOrders}
        />
      ),
      disablePadding: true,
    })
    .when(canReadServiceCase && serviceOrders.length > 0, {
      id: 'comments',
      label: i18n.t('entity.activityPanel.comments.title'),
      icon: 'communication/comment',
      component: <ServiceCaseCommentsTab serviceOrders={serviceOrders} />,
    })
    .whenFeatureEnabled(
      featureFlags.CUSTOM_NOTICES,
      buildCustomNoticesSidebarAction({
        resourceId: EntityResourceIds.serviceCase,
        recordId: props.serviceCaseId,
      })
    );

  return <ActivitySidebarV2 actions={actions} />;
}
